import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { environment } from './../../environments/environment';


@Injectable({
  providedIn: "root",
})
export class EncryptionService {
  private key = CryptoJS.enc.Utf8.parse(environment.EncodeKey); // 32 bytes key for AES-256
  private iv = CryptoJS.enc.Utf8.parse(environment.EncodeIVKey); // 16 bytes IV

  constructor() {}

  encrypt(plainText: string): string {
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), this.key, {
      keySize: 256 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  decrypt(encryptedText: string): string {
    // console.log(encryptedText)
    const decrypted = CryptoJS.AES.decrypt(encryptedText, this.key, {
      keySize: 256 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypted);
  }
}
